const landingPageContent = {
  catexpertBannerContent: [
    {
      id: 1,
      image: "https://cdn.catexpert.ab-inbev.com/assets/images/experience.svg",
      label: "LANDING.CONTENT.BANNER.CARD_1_LABEL",
      color: "#233B61",
      description: "LANDING.CONTENT.BANNER.CARD_1_DESC",
    },
    {
      id: 2,
      image: "https://cdn.catexpert.ab-inbev.com/assets/images/industry.svg",
      label: "LANDING.CONTENT.BANNER.CARD_2_LABEL",
      color: "#0091FF",
      description: "LANDING.CONTENT.BANNER.CARD_2_DESC",
    },
    {
      id: 3,
      image: "https://cdn.catexpert.ab-inbev.com/assets/images/partnerships.svg",
      label: "LANDING.CONTENT.BANNER.CARD_3_LABEL",
      color: "#B64437",
      description: "LANDING.CONTENT.BANNER.CARD_3_DESC",
    },
  ],
  catexpertFeatures: [
    {
      id: 1,
      bg_image: "https://cdn.catexpert.ab-inbev.com/assets/images/data.png",
      label: "LANDING.CONTENT.FEATURES.ITEM_1_LABEL",
      short_description:
        "LANDING.CONTENT.FEATURES.ITEM_1_DESC",
    },
    {
      id: 2,
      bg_image: "https://cdn.catexpert.ab-inbev.com/assets/images/cluster.png",
      label: "LANDING.CONTENT.FEATURES.ITEM_2_LABEL",
      short_description:
        "LANDING.CONTENT.FEATURES.ITEM_2_DESC",
    },
    {
      id: 3,
      bg_image: "https://cdn.catexpert.ab-inbev.com/assets/images/assortment.jpg",
      label: "LANDING.CONTENT.FEATURES.ITEM_3_LABEL",
      short_description:
        "LANDING.CONTENT.FEATURES.ITEM_3_DESC",
    },
    {
      id: 4,
      bg_image: "https://cdn.catexpert.ab-inbev.com/assets/images/delist.png",
      label: "LANDING.CONTENT.FEATURES.ITEM_4_LABEL",
      short_description:
        "LANDING.CONTENT.FEATURES.ITEM_4_DESC",
    },
    {
      id: 5,
      bg_image: "https://cdn.catexpert.ab-inbev.com/assets/images/simulate.png",
      label: "LANDING.CONTENT.FEATURES.ITEM_5_LABEL",
      short_description:
        "LANDING.CONTENT.FEATURES.ITEM_5_DESC",
    },
    {
      id: 6,
      bg_image: "https://cdn.catexpert.ab-inbev.com/assets/images/business.png",
      label: "LANDING.CONTENT.FEATURES.ITEM_6_LABEL",
      short_description:
        "LANDING.CONTENT.FEATURES.ITEM_6_DESC",
    },
  ],
  catexpertFaq: [
    {
      question: "LANDING.FAQ.ITEM_1_QUESTION",
      answer: "LANDING.FAQ.ITEM_1_ANSWER",
    },
    {
      question: "LANDING.FAQ.ITEM_2_QUESTION",
      answer: "LANDING.FAQ.ITEM_2_ANSWER",
    },
    {
      question: "LANDING.FAQ.ITEM_3_QUESTION",
      answer: "LANDING.FAQ.ITEM_3_ANSWER",
    },
    {
      question: "LANDING.FAQ.ITEM_4_QUESTION",
      answer: "LANDING.FAQ.ITEM_4_ANSWER",
    },
    {
      question: "LANDING.FAQ.ITEM_5_QUESTION",
      answer: "LANDING.FAQ.ITEM_5_ANSWER",
    },
  ],
};

export { landingPageContent };
